import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { TestSessionProvider } from "./context/TestSessionContext";
import HomePage from "./pages/HomePage";
import ResultPage from "./pages/ResultPage";
import TestPage from "./pages/TestPage";

function App() {
  return (
    <BrowserRouter>
      <TestSessionProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </TestSessionProvider>
    </BrowserRouter>
  );
}

export default App;
